// export PATH="$HOME/.npm-global/bin:$PATH"
// import "./styles/style.scss"
import './App.css';
import { BrowserRouter, Route } from 'react-router-dom';

import Home from './component/index';
import Admin from './component/admin/index';

function App() {
  return (
    <>
    <BrowserRouter>
      <Route exact path="/" component={Home} />
      <Route exact path="/info" component={Admin} />
    </BrowserRouter>
    </>
  );
}

export default App;
